import { render, staticRenderFns } from "./ScheduleDetail.vue?vue&type=template&id=463dbaf6&scoped=true&"
import script from "./ScheduleDetail.vue?vue&type=script&lang=js&"
export * from "./ScheduleDetail.vue?vue&type=script&lang=js&"
import style0 from "./ScheduleDetail.vue?vue&type=style&index=0&id=463dbaf6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463dbaf6",
  null
  
)

export default component.exports